import { createDateColumn } from "./date-column";
import {
  createMoneyColumn,
  createNumberColumn,
  createPercentageColumn,
} from "./numeric-column";
import { createStringColumn } from "./string-column";

export * from "./date-column";
export * from "./numeric-column";
export * from "./string-column";

export const createColumn = (getter, col, decimalsDefault, translate) => {
  switch (col.type) {
    case "number":
      return createNumberColumn(getter, col, decimalsDefault, translate);

    case "percentage":
      return createPercentageColumn(getter, col, decimalsDefault, translate);

    case "money":
      return createMoneyColumn(getter, col, decimalsDefault, translate);

    case "date":
      return createDateColumn(getter, col);

    default:
      return createStringColumn(getter, col);
  }
};
